var app = angular.module('leonardo');

var UserInitialDirective = function(ConfigThemeService, AccountUserService, AuthDataService) {
  return {
    restrict: 'C',
    scope: {
      initialsColor: '@',
      object: '='
    },
    link: function (scope, element) {

      scope.setColor = function() {
        var color = scope.initialsColor ? ConfigThemeService.getColor(scope.initialsColor) : ConfigThemeService.config.theme_config.secondaryColor;
        if (scope.object) {
          if (AuthDataService.isAdmin() && !isNull(scope.object.client_instance)) {
            element.css('background-color', ConfigThemeService.getColor('auxColor'));
          }
          else {
            var account_id = (scope.object.account && scope.object.account.id) ? scope.object.account.id : scope.object.account;
            var managed_by = (scope.object.managed_by && scope.object.managed_by.id) ? scope.object.managed_by.id : scope.object.managed_by;
            if (((account_id == AccountUserService.currentAccountUser.account) && (!managed_by))
              || (managed_by == AccountUserService.currentAccountUser.account)){
              element.css('background-color', color);
            }
            else {
              element.css('background-color', ConfigThemeService.getColor('auxColor'));
            }
          }
        }
        else {
          element.css('background-color', color);
        }
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('userInitials', ['ConfigThemeService', 'AccountUserService', 'AuthDataService', UserInitialDirective]);
